import styled from '@emotion/styled';
import { withConfig } from '../Config';
import { Color } from '../../../styles/Color';

interface IFormattedTimeProps {
	/** Date object or epoch timestamp in seconds */
	value: number | Date;
	children?: string;
	isStrikeThrough?: boolean;
	isNewTime?: boolean;
	screenReaderLabel?: string;
}

export const FormattedTime = withConfig<IFormattedTimeProps>(
	({
		value: dateOrTimestamp,
		config,
		children,
		isStrikeThrough = false,
		isNewTime = false,
		screenReaderLabel,
	}) => {
		const date =
			dateOrTimestamp instanceof Date
				? dateOrTimestamp
				: new Date(dateOrTimestamp * 1000);

		const { theme, dateTimeFormat } = config;

		const formattedTime = new Intl.DateTimeFormat(dateTimeFormat.locale, {
			timeZone: dateTimeFormat.timeZone,
			...theme.time.format,
		}).format(date);

		return (
			<StyledFormattedTime
				isStrikeThrough={isStrikeThrough}
				isNewTime={isNewTime}
			>
				{screenReaderLabel && (
					<ScreenReaderLabel>{`${screenReaderLabel}\u00A0`}</ScreenReaderLabel>
				)}
				{`${
					(children ? `${children} ` : '') + formattedTime
				} \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0`}
			</StyledFormattedTime>
		);
	},
);

const StyledFormattedTime = styled.div<{
	isStrikeThrough: boolean;
	isNewTime: boolean;
}>`
	position: relative;
	white-space: nowrap;

	${({ isStrikeThrough }) =>
		isStrikeThrough && `text-decoration: ${Color.Error} line-through;`}

	${({ isNewTime }) =>
		isNewTime &&
		` color: ${Color.Error};
	`}
`;

const ScreenReaderLabel = styled.span`
	position: absolute;
	opacity: 0;
	pointer-events: none;
`;
